const TagList = () => import('@/vuepage/college-manage/tagList')
const ClassifyList = () => import('@/vuepage/college-manage/classifyList')
const ArticleList = () => import('@/vuepage/college-manage/articleList')
const AddArticle = () => import('@/vuepage/college-manage/addArticle')
const HomeIntroduce = () => import('@/vuepage/college-manage/homeIntroduce')
const RelatedArticles = () => import('@/vuepage/college-manage/relatedArticles')
export default [
    {
        path: '/tag-list',
        component: TagList,
        name: '/tag-list',
        meta: [
            { name: '企微学院管理' },
            { name: '标签管理', activeRoute: '/tag-list' }
        ]
    },

    {
        path: '/classify-list',
        component: ClassifyList,
        name: '/classify-list',
        meta: [
            { name: '企微学院管理' },
            { name: '分类管理', activeRoute: '/classify-list' }
        ]
    },

    {
        path: '/article-list',
        component: ArticleList,
        name: '/article-list',
        meta: [
            { name: '企微学院管理' },
            { name: '文章列表', activeRoute: '/article-list' }
        ]
    },

    {
        path: '/add-article',
        component: AddArticle,
        name: '/add-article',
        meta: [
            { name: '企微学院管理' },
            { name: '新建文章', activeRoute: '/add-article' }
        ]
    },

    {
        path: '/home-introduce',
        component: HomeIntroduce,
        name: '/home-introduce',
        meta: [
            { name: '企微学院管理' },
            { name: '首页设置推荐', activeRoute: '/home-introduce' }
        ]
    },

    {
        path: '/related-articles',
        component: RelatedArticles,
        name: '/related-articles',
        meta: [
            { name: '企微学院管理' },
            { name: '关联文章', activeRoute: '/related-articles' }
        ]
    }
]
